import { createStore, combineReducers, applyMiddleware } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import rootSaga from 'core/sagas/index';

import accountReducer from 'features/Account/accountReducer';
import * as fromNotify from 'components/ui/Notify/store/reducer';
import { reducer as profileReducer } from 'features/Settings/profile/store/reducers';
import deviceReducer from 'store/deviceReducer';
import userReducer from 'store/userReducer';
import clientReducer from 'store/clientReducer';
import testReducer from 'store/testReducer';
import testFormReducer from 'store/test-form-reducer';
import { paginationReducerFor } from 'store/pagination-reducer';
import fileDownloadReducer from 'components/ui/FileDownload/reducer';
import SignupReducer from '../../features/Signup/duck/signup-reducer';

const sagaMiddleware = createSagaMiddleware()

const configureStore = () => {
  const reducer = combineReducers({
    account: accountReducer,
    client: combineReducers({
      data: clientReducer,
      pagination: paginationReducerFor('CLIENTS'),
    }),
    device: combineReducers({
      data: deviceReducer,
      pagination: paginationReducerFor('DEVICES'),
    }),
    fileDownload: fileDownloadReducer,
    form: formReducer,
    notification: fromNotify.reducer,
    profile: profileReducer,
    test: combineReducers({
      data: testReducer,
      pagination: paginationReducerFor('TESTS'),
    }),
    testForm: testFormReducer,
    user: userReducer,
    signup: SignupReducer,
  });

  const store = createStore(
    reducer,
    composeWithDevTools(),
    applyMiddleware(sagaMiddleware),
  );

  sagaMiddleware.run(rootSaga);

  return store;
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/core/store/configure.js